import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          {/* <Link to="mailto:contact@Padmaster.app">Contact</Link> */}
          <a href="mailto:contact@Padmaster.app">Contact</a>
        </li>
        <li>
          <Link target="_blank" to="/privacy-policy.html">Privacy Policy</Link>
        </li>
        <li>
          <Link target="_blank" to="/terms-of-use.html">Terms of use</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;